import React from "react";
import { Box } from "@mui/material";
const WooCommerceIcon = ({ size = 40, alt = "WooCommerce", sx = {}, ...props }) => {
  return (
    <Box
      component="img"
      src={"/woocommerce-icon.png"}
      alt={alt}
      sx={{
        width: size,
        height: size,
        objectFit: "contain",
        display: "inline-block",
        verticalAlign: "middle",
        ...sx, // allow style overrides from parent
      }}
      {...props}
    />
  );
};

export default WooCommerceIcon;
